import { useCallback } from 'react'
import { ContentStateInterface } from '../../@types/types'
import {
  resetConstructionYearIfUnknown,
  resetConsumptionContainsWarmWaterIfNecessary,
  resetEnergyCertificateIfNotAvailable,
  resetPriceIfNecessary,
} from '../pages/insertionPage/insertionEditorValidators/Resets'
import { validateAndSaveInsertion } from '../../redux/thunks/insertionData/insertionData'
import { doAutoSaveDecider } from '../../redux/thunks/wizard/doAutoSaveDecider'
import { fetchRentValuationDebounced } from '../../redux/thunks/valuation/fetchRentValuationIfReady'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useStore } from 'react-redux'
import { InitState } from '../../redux/reducers/root/initialState'
import { useIsSaved } from '../../redux/reducers/insertion/insertionFeature'
import { useIsRecommendedPriceEnabled } from '../pages/insertionPage/UseIsRecommendedPriceEnabled'
import _ from 'lodash'

type InsertionDataUpdater = (oldData: ContentStateInterface) => ContentStateInterface

export function useOnChangeV2() {
  const dispatch = useAppDispatch()
  const store = useStore<InitState>()

  const isSaved = useAppSelector(useIsSaved)
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()

  return useCallback<(old: InsertionDataUpdater) => void>(
    (updaterFunction: InsertionDataUpdater) => {
      const newInsertionData = _.cloneDeep(updaterFunction(store.getState().insertionFeature.insertionData))
      const flowInformation = store.getState().flowFeature.flowInformation

      afterUpdateChecks(newInsertionData)
      dispatch(validateAndSaveInsertion(newInsertionData, true))
      isRecommendedPriceEnabled && dispatch(fetchRentValuationDebounced())

      !isSaved && dispatch(doAutoSaveDecider(flowInformation.validationSchema))
    },
    [store, dispatch, isSaved, isRecommendedPriceEnabled]
  )
}

function afterUpdateChecks(insertionData: ContentStateInterface) {
  resetConsumptionContainsWarmWaterIfNecessary(insertionData, !insertionData.manualCountry)
  resetEnergyCertificateIfNotAvailable(insertionData)
  resetConstructionYearIfUnknown(insertionData)
  resetPriceIfNecessary(insertionData)
}
